import { Center } from '@astryxdesign/core/Center';
import { EmptyState } from '@astryxdesign/core/EmptyState';

/** Shown when the build was made without VITE_SUPABASE_URL / VITE_SUPABASE_PUBLISHABLE_KEY. */
export function ConfigErrorPage() {
  return (
    <Center minHeight="100dvh" padding={6}>
      <EmptyState
        headingLevel={1}
        title="Сайт не настроен"
        description="Сборка выполнена без адреса базы данных. Владельцу сайта: задайте VITE_SUPABASE_URL и VITE_SUPABASE_PUBLISHABLE_KEY и пересоберите (см. SETUP.md)."
      />
    </Center>
  );
}
